
import { darken } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from '.';
import { LFC } from '../Legacy';

const Section = styled.div<{ flush?: boolean }>`
    max-width: 64rem;
    padding: .5rem ${p => p.flush ? 0 : 2}rem;
`;

const LargeHeading = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin: .5rem 0 0rem; 
    color: ${Colors.text};
    font-weight: 450;
    font-size: 1.5rem;
`;

const Heading = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin: .5rem 0 1rem; 
    color: ${Colors.text};
    font-weight: 450;
    font-size: 1.125rem;
`;

const HeadingAction = styled.div`
    display: flex;
    align-items: center;
    color: ${Colors.primary};
    margin-left: auto;
    cursor: pointer;
    user-select: none;

    &:active {
        color: ${darken(0.2, Colors.primary)};
    }
    &:hover {
        color: ${darken(0.1, Colors.primary)};
    }
`;

const DetailTable: LFC = ({ children }) =>
    <table style={{ position: 'relative', width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
            {children}
        </tbody>
    </table>;

const DetailRow = styled.tr`
    margin: 0.25rem 0;
    color: ${Colors.text};
    font-size: 1rem;
    border-bottom: dotted 1px gainsboro;
`;

const DetailCell = styled.td<{ shrink?: boolean }>`
    position: relative;
    padding: 0.25rem 2rem 0.25rem 0;
    vertical-align: top;
    &:last-child {
        padding-right: 0;
    }
    ${p => !p.shrink ? '' : css`
        width: 1px;
        white-space: nowrap;
    `}
`;

const DetailAction = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    color: ${Colors.primary};
    margin-left: 1rem;

    &:active {
        color: ${darken(0.2, Colors.primary)};
    }

    &:hover {
        cursor: pointer;
        user-select: none;
        color: ${darken(0.1, Colors.primary)};
    }
`;

const ListItem = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    min-height: 2.5rem;
    padding: .5rem 0;
    color: ${Colors.text};

    &:hover {
        &:after {
            pointer-events: none;
            content: '';
            position: absolute;
            inset: 0;
            border-bottom: dotted 1px gainsboro;
            border-top: dotted 1px gainsboro;
        }
    }
`;

const ListItemRow = styled.div`
    display: flex;
    flex: 1 1 100%;
    align-items: center;
`;

const ListLabel = styled.div`
    margin-right: .875em;
`;

const ListDetails = styled.div`
    flex-basis: 100%;
    margin-top: .5em;
    font-size: .75rem;
`;

const ListAction = styled.div`
    color: ${Colors.primary};
    margin-left: auto;

    &:active {
        color: ${darken(0.2, Colors.primary)};
    }

    &:hover {
        cursor: pointer;
        user-select: none;
        color: ${darken(0.1, Colors.primary)};
    }
`;

const Base = styled.div`
    display: contents;
`;

export const InfoView = Object.assign(Base, {
    Section,
    LargeHeading,
    Heading,
    HeadingAction,
    DetailTable,
    DetailRow,
    DetailCell,
    DetailAction,
    ListItem,
    ListItemRow,
    ListLabel,
    ListDetails,
    ListAction,
});
